import(/* webpackMode: "eager", webpackExports: ["__esModule","default"] */ "/opt/build/repo/node_modules/.pnpm/next@15.4.6_react-dom@19.1.0_react@19.1.0__react@19.1.0/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager" */ "/opt/build/repo/node_modules/.pnpm/next@15.4.6_react-dom@19.1.0_react@19.1.0__react@19.1.0/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager" */ "/opt/build/repo/src/app/(home)/(ui)/Hero.tsx");
;
import(/* webpackMode: "eager" */ "/opt/build/repo/src/features/filterByCost/ui/FilterByMinMax/FilterByMinMax.tsx");
;
import(/* webpackMode: "eager" */ "/opt/build/repo/src/features/scroll-to-top/ui/ScrollToTopButton/ScrollToTopButton.tsx");
;
import(/* webpackMode: "eager" */ "/opt/build/repo/src/features/searchByQuery/ui/Search/Search.tsx");
;
import(/* webpackMode: "eager" */ "/opt/build/repo/src/features/selectBrand/ui/ProductBrand/ProductBrand.tsx");
;
import(/* webpackMode: "eager" */ "/opt/build/repo/src/features/selectCategory/ui/ProductCategory/ProductCategory.tsx");
;
import(/* webpackMode: "eager" */ "/opt/build/repo/src/widgets/Header/Header.tsx");
;
import(/* webpackMode: "eager" */ "/opt/build/repo/src/widgets/product-list/ui/ProductList/ProductList.tsx");
